import React from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {convertDatoCmsImgPathsToLocal} from '../graphql/datoCmsDataFactory'
import {themes} from '../util/theme'

const AvInfo = ({text, imageUrl, imageDarkUrl, theme, themeStyles}) => {
    const themedImageUrl = {
        light: imageUrl,
        air: imageUrl,
        dark: imageDarkUrl,
        night: imageDarkUrl,
    }

    return (
        <section
            css={css`
                display: flex;
                width: auto;
                flex-basis: 48%;
                max-width: 100%;
                height: 100%;
                min-height: 104px;
                box-shadow: 0px 10px 20px rgba(32, 41, 69, 0.1);
                border-radius: 4px;
                margin-bottom: 24px;
                padding: 16px 32px;
                align-items: center;
                background-color: ${themeStyles.secondaryBackgroundColor};
                border: solid 1px ${themeStyles.boxBorderColor};

                @media (max-width: 600px) {
                    padding: 16px;
                    margin-bottom: 24px;
                }
            `}
        >
            <img src={convertDatoCmsImgPathsToLocal(themedImageUrl[theme])} alt="" />
            <div
                css={css`
                    font-weight: 400;
                    font-size: 16px;
                    padding-left: 24px;
                    color: ${themeStyles.primaryTextColor};

                    p {
                        line-height: 24px;
                    }
                `}
            >
                {text}
            </div>
        </section>
    )
}

AvInfo.propTypes = {
    themeStyles: PropTypes.object,
}

AvInfo.defaultProps = {
    themeStyles: themes.light,
}

export default AvInfo
